import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { ModalProvider } from "./context/ModalContext";
import { AppDataProvider } from "./context/AppDataContext";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import CreatePost from "./pages/CreatePost";
import CreateReel from "./pages/CreateReel";
import Scheduled from "./pages/Scheduled";
import Published from "./pages/Published";
import Failed from "./pages/Failed";
import Calendar from "./pages/Calendar";
import Accounts from "./pages/Accounts";
import Analytics from "./pages/Analytics";
import Brands from "./pages/Brands";
import Settings from "./pages/Settings";
import "./styles/style.css";
import "./styles/responsive.css";

/**
 * Ported from the standalone Instagram Scheduler project's App.jsx + the
 * provider stack that used to live in its own main.jsx (no separate
 * <BrowserRouter> here -- the CRM's own App.js already provides one at the
 * top level). Everything renders inside .rr-igscheduler-scope, which every
 * selector in styles/style.css + responsive.css was mechanically prefixed
 * with during the port -- including the original global `*`/`body` reset --
 * so none of it can leak into (or be affected by) the rest of the CRM.
 */
export default function IgSchedulerApp() {
  return (
    <div className="rr-igscheduler-scope">
      <AuthProvider>
        <ToastProvider>
          <ModalProvider>
            <Routes>
              {/* Relative, not "/instagram-scheduler/app" -- a nested
                  <Routes> auto-strips whatever prefix the ancestor
                  CRM-level <Route path="/instagram-scheduler/*"> already
                  matched, so this only ever sees the remainder ("/app...").
                  Real navigation targets (Link to=/navigate() calls
                  elsewhere in this app, and the catch-all redirect below)
                  are a different thing -- those generate real browser URLs
                  and correctly stay fully prefixed. */}
              <Route
                path="/app"
                element={
                  <AppDataProvider>
                    <Layout />
                  </AppDataProvider>
                }
              >
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="create-post" element={<CreatePost />} />
                <Route path="create-reel" element={<CreateReel />} />
                <Route path="scheduled" element={<Scheduled />} />
                <Route path="published" element={<Published />} />
                <Route path="failed" element={<Failed />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="brands" element={<Brands />} />
                <Route path="accounts" element={<Accounts />} />
                <Route path="metrics" element={<Navigate to="../analytics" replace />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="settings" element={<Settings />} />
                <Route index element={<Navigate to="dashboard" replace />} />
              </Route>

              <Route path="*" element={<Navigate to="/instagram-scheduler/app/dashboard" replace />} />
            </Routes>
          </ModalProvider>
        </ToastProvider>
      </AuthProvider>
    </div>
  );
}
